'use client';

import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Check } from '@phosphor-icons/react/dist/ssr/Check';
import { Copy } from '@phosphor-icons/react/dist/ssr/Copy';

function CopyButton({ text }: { text?: string }): React.JSX.Element | null {
  const [showCopiedIcon, setShowCopiedIcon] = useState(false);

  if (!text || text === '') return null;

  const handleCopyClick = async (): Promise<void> => {
    setShowCopiedIcon(true);
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      //   console.error('Error copying text to clipboard', err);
    }

    setTimeout(() => {
      setShowCopiedIcon(false);
    }, 2000);
  };

  return (
    <Button
      variant="text"
      size="large"
      onClick={(e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        void handleCopyClick();
      }}
      disableRipple
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'none !important',
        p: 0,
      }}
    >
      {showCopiedIcon ? <Check /> : <Copy />}
    </Button>
  );
}

export default CopyButton;
